import { Component, Input, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-add-node-dialog',
    templateUrl: './add-node-dialog.component.html',
    styleUrls: ['./add-node-dialog.component.scss'],
    standalone: false
})
export class AddNodeDialogComponent {
    @Input() public newNodeName: string = '';

    constructor(
        public dialogRef: MatDialogRef<AddNodeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    closeDialog(): void {
        // Pass the undefined back to the parent component
        this.dialogRef.close();
    }

    addNode(): void {
        // Pass the new node back to the parent component
        this.dialogRef.close({ description : this.newNodeName});
    }
}